
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"d":"M18.194 11.98a.772.772 0 01.023.188v4.653c0 .322-.2.61-.501.723l-5.134 1.925c-.35.132-.735.132-1.084 0l-5.134-1.925a.772.772 0 01-.502-.723v-4.653a.772.772 0 01.96-.75l4.843 1.212c.246.061.503.061.75 0l4.843-1.211a.772.772 0 01.936.562zm-5.645-5.6l7.893 2.204a.386.386 0 01.093.704l-.001 4.114.48.48-.867.865-.865-.865.479-.481V9.518l-7.212 2.013a1.544 1.544 0 01-.83 0L3.824 9.328a.386.386 0 010-.744l7.893-2.203c.272-.076.56-.076.83 0z","fill":"#000","fill-opacity":".65","fill-rule":"nonzero"}})])])
          )
        }
      }
    